/**
* Allows displaying a summary of validation errors, with links to the corresponding fields. (To be used in conjuction with oly-form-validation-summary directive)
* Usage Example:
***************************************************************************************************************************
*  <oly-form-validation-summary-display></oly-form-validation-summary-display>
*  <form  name= "myForm" oly-form-validation-summary ng-submit=blah() >
*      <input id = "myForm-Firstname" name = "FirstName" ngModel="FirstNameModel" />
*  </form
********************************************************************************************************************************
* Note that the id of the input Fields should be "<form Name>-<input field Name>" for the links to work.
* Also note that validity for the input field needs to be "false" for it to display in the summary. Server errors will explicitly need to have validity set to false for the corresponding field.
*/

const _ = require('lodash');

module.exports = function (olyFormValidationSummaryService, moveFocus) {
    return {
        restrict: 'E',
        scope: {
            userMessage: '@',
            serverErrorMessage: '=?'
        },
        link(scope) {

            scope.validationErrors = function () { return olyFormValidationSummaryService.validationErrors(); };

            scope.errorCount = function () { return _.size(scope.validationErrors()); };

            scope.hasValidationErrors = function () { return scope.errorCount() > 0; };

            scope.setFocusOn = function (elementId) {
                moveFocus(`#${elementId}`);
            };

            scope.firstFieldErrorId = function () {
                return _.keys(scope.validationErrors())[0];
            };

            scope.watchErrorCount = 0;

            scope.$watch(
                function () {
                    return olyFormValidationSummaryService.focusSummary;
                },
                function (newValue) {
                    if (newValue === true) {
                        // TODO: need to scope this summary to the form it is validating so as not to focus the wrong summary with incorrect count
                        moveFocus('._validationSummary:first');
                        olyFormValidationSummaryService.focusSummary = false;
                    }
                }
            );

            scope.$watch(function () { return scope.serverErrorMessage; },
                function (newValue, oldValue) {
                    if (newValue !== oldValue) {
                        scope.serverErrorMessage = newValue;
                    }
                }
            );

        },
        template: require('./form-validation-summary-display-template.html').trim()
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/form-validation-summary/form-validation-summary-display-directive.js
 **/